import styled from 'styled-components';

import { Box } from '@hivebrite/design-system/Box';

export const VerticalDivider = styled(Box).attrs(() => ({
  backgroundColor: '#CECECE',
  height: '16px',
  width: '1px',
}))`
  border-radius: 1px;
`;
